export enum ProductGradeEnum {
  Unknown = 0,
  Food = 1,
  Technical = 2,
  FoodAndTechnical = Food | Technical,
  Feed = 4,
  FoodAndFeed = Food | Feed,
  TechnicalAndFeed = Technical | Feed,
  FoodTechnicalAndFeed = Food | Technical | Feed,
}
